import { render, staticRenderFns } from "./SmoothrPayPayouts.vue?vue&type=template&id=0187cfc4"
import script from "./SmoothrPayPayouts.vue?vue&type=script&lang=ts"
export * from "./SmoothrPayPayouts.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports